import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import { Toaster } from "sonner";

/**
 * App-wide toast host (sonner). Mount once in main.tsx.
 * Fire toasts with `import { toast } from "sonner"`.
 * Colors come from the theme tokens in App.css, so light/dark both work.
 */
const AppToaster = () => (
  <Toaster
    position="top-right"
    duration={4000}
    closeButton
    icons={{
      success: (
        <CheckCircleRoundedIcon className="text-(color:--color-content-positive)" />
      ),
      error: <ErrorRoundedIcon className="text-(color:--color-content-negative)" />,
      warning: (
        <WarningAmberRoundedIcon className="text-(color:--color-content-warning)" />
      ),
      info: <InfoRoundedIcon className="text-(color:--color-content-accent)" />,
    }}
    toastOptions={{
      classNames: {
        toast:
          "!rounded-[16px] !border !border-(color:--color-border) !bg-(--color-surface-primary) !text-(color:--color-content-primary) !shadow-lg !font-poppins",
        title: "!text-[14px] !font-medium",
        description: "!text-[13px] !text-(color:--color-content-secondary)",
        closeButton:
          "!border-(color:--color-border) !bg-(--color-surface-primary) !text-(color:--color-content-secondary)",
      },
    }}
  />
);

export default AppToaster;
